module.exports = __webpack_public_path__ + "img/checkmark.3c9c2ff0.svg";